@if (!isLoading) {
  <div class="container"
    >
    <div class="progress-background"
      [class]="status">
      <div class="primary-progress-bar"
        [style.width.%]="percent * 100">
        <div class="primary-progress-bar-content"
          [class.align-left]="titleKey">
          @if (titleKey) {
            <span class="title"
            [translate]="titleKey"></span>
          }
          @if (value !== undefined) {
            @if (isPercent) {
              <span>
                {{value | percent }}
              </span>
            }
            @if (!isPercent && value) {
              <span>
                {{value | formatNumber }}
              </span>
            }
          }
          <ng-content select="[main]" />
        </div>
      </div>
      <div class="primary-progress-bar-remaining">
        <ng-content />
      </div>
    </div>
  </div>
} @else {
  <div class="skeleton-container">
    <div class="sk-line">
    </div>
  </div>
}